
import { RangerSourceMapEntityDecoratorBase } from './ranger-source-map.decorator.base';


export class RangerSourceMapEntityDecorator extends RangerSourceMapEntityDecoratorBase {
  constructor() {
    super();
  }
}



